<template>
  <div class="relative">
    <i-heroicons-pencil-solid />
    <span class="absolute inset-x-px -bottom-px h-0.5 rounded bg-black"></span>
  </div>
</template>
